import { render, staticRenderFns } from "./component-doc.vue?vue&type=template&id=3abcd5f8&scoped=true&"
import script from "./component-doc.vue?vue&type=script&lang=js&"
export * from "./component-doc.vue?vue&type=script&lang=js&"
import style0 from "./component-doc.vue?vue&type=style&index=0&id=3abcd5f8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abcd5f8",
  null
  
)

export default component.exports